module.exports = __webpack_public_path__ + "static/media/logo.01e8a5a2.svg";